import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

const TrendChart = ({ data, dataKeys, colors, type = 'line', height = 180 }) => {
  const formatDate = (dateStr) => {
    try {
      return format(new Date(dateStr), 'MMM dd');
    } catch {
      return dateStr;
    }
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
        <defs>
          {dataKeys.map((key, index) => (
            <linearGradient key={`gradient-${key.dataKey}`} id={`gradient-${key.dataKey}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={colors[index]} stopOpacity={0.3}/>
              <stop offset="95%" stopColor={colors[index]} stopOpacity={0}/>
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E2E2" vertical={false} opacity={0.5} />
        <XAxis 
          dataKey="date" 
          tickFormatter={formatDate}
          stroke="#A8A9AD"
          style={{ fontSize: '10px', fontWeight: 600 }}
          tickLine={false}
          axisLine={{ stroke: '#E2E2E2', strokeWidth: 1 }}
          tick={{ fill: '#101820' }}
        />
        <YAxis 
          stroke="#A8A9AD" 
          style={{ fontSize: '10px', fontWeight: 600 }}
          tickLine={false}
          axisLine={{ stroke: '#E2E2E2', strokeWidth: 1 }}
          tick={{ fill: '#A8A9AD' }}
        />
        <Tooltip 
          labelFormatter={formatDate}
          contentStyle={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.98)', 
            border: '1px solid #E2E2E2',
            borderRadius: '10px',
            boxShadow: '0 10px 25px -5px rgba(0, 102, 255, 0.1), 0 8px 10px -6px rgba(16, 24, 32, 0.1)',
            padding: '10px 14px',
            fontSize: '12px',
            fontWeight: 600
          }}
          labelStyle={{ fontWeight: 700, marginBottom: '4px', color: '#101820' }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '12px', fontWeight: 500 }}
          iconType="circle"
        />
        {dataKeys.map((key, index) => (
          <Line
            key={key.dataKey}
            type="monotone"
            dataKey={key.dataKey}
            name={key.name}
            stroke={colors[index]}
            strokeWidth={3}
            dot={{ r: 4, fill: colors[index], strokeWidth: 2, stroke: '#fff' }}
            activeDot={{ r: 6, strokeWidth: 2, stroke: '#fff', fill: colors[index] }}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TrendChart;